import ProduitStockConfigNiveauxController from './produit.stock.config.niveaux.controller';

export default {
    template: require('./produit.stock.config.niveaux.tpl.html'),
    controller: ProduitStockConfigNiveauxController,
    bindings: {}
};
